import { ProfileAttributes } from "../profile-attributes/profile-attributes.js";
import { DataBaseComponent } from "./data-base-component.js";


export class DataProfilesAttributesComponent extends DataBaseComponent {
    static webComponentName: string = "data-profiles-attributes";
    protected _templateId: string = "data-profiles-attributes";
    protected profileAttributesComponent:ProfileAttributes|null=null;
    get value(): any {
        const superValue = super.value;
        const profileValue = this.profileAttributesComponent?.value;
        // ProfileAttributes è sempre la fonte di verità quando disponibile
        if (this.profileAttributesComponent) {
            return profileValue || [];
        }
        return superValue || [];
    }
     set value(newValue: any) {
        super.value = newValue;
    }
    constructor() {
        super();
    }
    addDataForTemplate(): Record<string, any> {
        return {
            readOnly:this.readOnly,
            profileAttributes: this.value
        };
    }
    protected afterRender(): void {
        super.afterRender();
        this.profileAttributesComponent = this.querySelector<ProfileAttributes>('profile-attributes');
        this.profileAttributesComponent?.addEventListener('value-changed', (event: Event) => {
            event.stopPropagation(); // Prevent event from bubbling up
            // Non aggiornare super.value - ProfileAttributes è la fonte di verità
            // Propaga l'evento al form system se necessario
            this.dispatch('form-changed', { value: this.value });
        });
    }

}